@if (isVisible() || instantiateWhenHidden()) {
  <!-- To retrieve common data from the block, implements BlockCommonDataInterface in your block and the input: readonly common = input<BlockCommon>()-->
  <div
    class="cb2-pick-bloc"
    [hidden]="!isVisible() && instantiateWhenHidden()"
    [appCb2PickBloc]="resolvedBlockId"
  >
    @if (wrapCartPageColumnBlock()) {
      <div
        class="cart-page-column-block"
        [style.backgroundColor]="
          cartPageColumnBackgroundColor() | contentBuilderColor: cartPageColumnBackgroundDefault
        "
      >
        <app-component-factory
          [data]="data()"
          [componentClass]="$any(componentClass())"
          (isVisibleChanged)="isVisible.set($event)"
        ></app-component-factory>
      </div>
    } @else {
      <app-component-factory
        [data]="data()"
        [componentClass]="$any(componentClass())"
        (isVisibleChanged)="isVisible.set($event)"
      ></app-component-factory>
    }
  </div>
}
